import React, {useEffect} from "react";
import {useParams} from "react-router";
import Carousel from "react-bootstrap/Carousel";
import {Link} from "react-router-dom";
import {AccountBoxTwoTone, AppsTwoTone, ShareTwoTone} from "@mui/icons-material";

function Main() {
  const params=useParams();

  const href= window.location.href;
  const hToken=localStorage.getItem('hToken');
  const headers=hToken &&  new Headers();

  const ar = ["t1.jpeg","t2.jpeg","t3.jpeg","t4.jpeg","t5.jpeg","t6.jpeg","t7.jpeg","t8.jpeg","t9.jpeg","t10.jpeg","ugri.jpg"];
  useEffect(()=>{



  },[])
  return (
    <div className=' d-flex flex-col justify-between '>

      <Carousel fade>
        {ar.map((a, i) => (


          <Carousel.Item key={i}>
            <div style={{
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              width: '100%',
              height: '80vh',
              backgroundPosition: 'center center',
              backgroundImage: 'url(https://vids.memigration.info/' + a + ')'
            }}>


            </div>

            <Carousel.Caption>

            </Carousel.Caption>
          </Carousel.Item>


        ))}


      </Carousel>
      <div className="text-center p4 display-3 mt-2"><h2>Aleksandr Potolitsyn</h2></div>
      <div className="flex justify-center  content-center mt-4">
        <Link to="/cv" className="mx-1"> <AppsTwoTone fontSize="large" /></Link>

        <Link to="/about" className="mx-1">   <AccountBoxTwoTone fontSize="large"/></Link>


            <Link to="/contacts" className="mx-1">  <ShareTwoTone fontSize="large"/></Link>
      </div>

    </div>
  );
}

export default Main;
